<template>
    <v-app>
        <v-content>
            <router-view />
            <div class="loading-overlay" v-if="$store.state.app.loading">
                <div id="loading-indicator-box">
                    <loading-indicator style="transform: scale(0.36);margin-left: -4px;" />
                </div>
            </div>
        </v-content>
    </v-app>
</template>

<style scoped>
.loading-overlay {
    position: fixed;
    z-index: 9999;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
}

#loading-indicator-box {
  position: absolute;
  bottom: 40px;
  left: 40px;

  width: 60px;
  height: 60px;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  box-shadow: 0px 6px 20px rgba(27, 36, 61, 0.22);
  background: white;
}
</style>

<script>
import LoadingIndicator from '@/components/LoadingIndicator'

export default {
    components: { LoadingIndicator }
}
</script>


// WEBPACK FOOTER //
// src/Root.vue